import { render } from "./VideoDetails.vue?vue&type=template&id=48cf0fe3&scoped=true"
import script from "./VideoDetails.vue?vue&type=script&lang=js"
export * from "./VideoDetails.vue?vue&type=script&lang=js"

import "./VideoDetails.vue?vue&type=style&index=0&id=48cf0fe3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48cf0fe3"]])

export default __exports__